import { render } from "./ElHeader.vue?vue&type=template&id=663ea331"
import script from "./ElHeader.vue?vue&type=script&lang=js"
export * from "./ElHeader.vue?vue&type=script&lang=js"

import "./ElHeader.vue?vue&type=style&index=0&id=663ea331&lang=scss"

import exportComponent from "F:\\work\\angren\\cabinet\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__